const SKILL_INSTRUCTION_PREFIX_REGEXP = /^(Use the )"([^"\r\n]+)"( skill\.)\s*/;
export function formatSkillInstruction(skillName) {
    return `Use the "${skillName}" skill. `;
}
export function parseSkillInstructionPrefix(text) {
    const match = SKILL_INSTRUCTION_PREFIX_REGEXP.exec(text);
    const beforeMention = match?.[1];
    const skillName = match?.[2]?.trim();
    const instructionSuffix = match?.[3];
    if (!match || !beforeMention || !skillName || !instructionSuffix)
        return null;
    const remainingText = text.slice(match[0].length);
    return {
        beforeMention,
        skillName,
        afterMention: `${instructionSuffix}${remainingText ? ` ${remainingText}` : ''}`,
    };
}
//# sourceMappingURL=skillInstruction.js.map